










































import { Component, Vue } from 'vue-property-decorator';
import GameLogic, {Hotspot, HotspotOption, MenuType} from "../services/GameLogic";
import {TalkToPatientState} from "../store/store";
import LocaleText from '@/components/LocaleText.vue';
import { default as HotspotBubble, HotspotBubbleOrientation } from "./components/HotspotBubble.vue";

const HOTSPOTNAME:string = 'communiceren';

@Component({
    components: {HotspotBubble, LocaleText },
    mounted() {
        //console.log('DayGame mounted');
        //console.log(this.$route);
    },
    computed: {
        allowExit():boolean {
            //this.$store.state.dayState.talkedToPatientState == TalkToPatientState.finalized ||
            return this.$store.state.dayState.log.length > 0;
        },
        getPatientRoute():string { return '/day/' + this.$store.state.day + '/patient'; },
        showNurseOverlay():boolean {
            return this.$store.state.currentHotspot === Hotspot.NONE
                   && this.$route.name === 'nurse';
        },
        currentHotspots():Hotspot[] {
            const actions = GameLogic.getCurrentActions(this.$store.state, MenuType.Nurse);
            const result = GameLogic.getHotspots(this.$store.state, actions, false);
            return result;
        },
        allowCommunicate():boolean {
            let hotspot:Hotspot = GameLogic.getHotspotByName(this.$store.state, HOTSPOTNAME);
            return hotspot.actions.length > 0;
        }
    },
    methods: {
        getIconPosition(key:string):any {
            let pos = GameLogic.getRoomIconPosition(this.$store.state, key);
            //console.log(key, pos);
            if (undefined != pos) {
                return GameLogic.getPositionStyle(pos, 1920, 1080);
            } else {
                return '';
            }
        },
        handleHotspotClicked(hotspot:Hotspot):void {
            //console.log('[click]', hotspot.name);
            this.$store.state.currentHotspot = hotspot;
            this.$store.state.currentOption = HotspotOption.NONE;
            this.$router.push('hotspot');
        },
        handleExitClicked():void {
            this.$store.state.showExitConfirm = true;
            //console.log(this.$delier); // TODO : gebuik die .d. files denk ik
            //this.$router.push('/feedback/' + this.$store.state.day);
            //this.$router.push('feedback');
        },
        handleCommunicateClicked():void {
            this.$router.push('/day/' + this.$store.state.day + '/patient');
        }
    },
})
export default class NurseHotspotView extends Vue {}
